import { render, staticRenderFns } from "./DeliveryOrderSection.vue?vue&type=template&id=7be985a3&scoped=true&"
import script from "./DeliveryOrderSection.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderSection.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderSection.vue?vue&type=style&index=0&id=7be985a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be985a3",
  null
  
)

export default component.exports